<section class="reforma-previsional" *ngIf="!loading && entries.length > 0">
    <div class="header">
        <h2>Reforma Previsional</h2>
        <p>Descubre las últimas noticias y actualizaciones sobre la reforma previsional en Chile. Información clara y
            actual para entender los cambios en pensiones.</p>
    </div>

    <div class="carousel">
        <div class="carousel__track" #track [style.--items-per-view]="itemsPerView" [class.dragging]="isDragging"
            (scroll)="onScroll()" (pointerdown)="onPointerDown($event)" (pointermove)="onPointerMove($event)"
            (pointerup)="onPointerUp($event)" (pointercancel)="onPointerUp($event)"
            (pointerleave)="onPointerUp($event)">
            <button type="button" class="carousel__card" *ngFor="let entry of entries" (click)="goToEntry(entry)">
                <div class="carousel__image">
                    <img [src]="entry.fields.Imagen.url" [alt]="entry.fields.Imagen.alt_text || entry.meta.name">
                    <span class="carousel__play" *ngIf="entry.fields['Link video']" aria-hidden="true"></span>
                </div>
                <p class="carousel__title">{{ entry.meta.name }}</p>
                <p class="carousel__excerpt">{{ entry.fields.Extracto }}</p>
                <p class="carousel__date">{{ formatDate(entry.fields.Fecha) }}</p>
            </button>
        </div>
    </div>

    <div class="carousel__dots" *ngIf="totalPages > 1">
        <button type="button" *ngFor="let page of pages" class="carousel__dot" [class.active]="page === currentPage"
            (click)="scrollToPage(page)" [attr.aria-label]="'Ir a página ' + (page + 1)"></button>
    </div>
</section>
